import { async } from "@firebase/util";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { IProfileAgency } from "../../../@types/api-data.types";
import { AgentApi } from "../../../utils/api/Agent";
import { PropertyApi } from "../../../utils/api/Property";
import { getImageUrl } from "../../../utils/helpers/common";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { clientRoutes } from "../../../utils/routes";
import Loading from "../../loading/Loading";
import "./AgencyMenuDetails.scss";

const AgencyMenuDetails = ({
  handleClose,
  agencyData,
}: {
  handleClose: any;
  agencyData: IProfileAgency | null;
}) => {
  const [state, setState] = useState({
    isLoadingSwitch: false,
  });
  const navigate = useNavigate();
  const onClickSwitch = async () => {
    let userData: any = LocalStorageHelpers.getAgencyData();

    setState({
      ...state,
      isLoadingSwitch: true,
    });

    let formData = new FormData();
    formData.append("switch_to_user_role", "agent");
    formData.append("user_id", userData?.principal_agent_id?._id || "");
    let res = await AgentApi?.switchUserProfile(formData);

    if (res?.data?.success) {
      toast.custom(
        (t) => (
          <div
            className={`switch-toast ${
              t.visible ? "animate-enter" : "animate-leave"
            }`}
          >
            <span>Switched to Agent profile</span>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="switch-toast-close"
            >
              ✕
            </button>
          </div>
        ),
        {
          position: "bottom-right",
          duration: 1000,
        }
      );
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      toast.error(res?.data?.message || "User not switch please reload!");
    }

    setState({
      ...state,
      isLoadingSwitch: false,
    });
  };
  return (
    <div className="agency-menu-details-container">
      <div
        className="header-menu-agency-contain-container"
        style={{
          backgroundColor: `rgb(${agencyData?.theme_colors[0].r}, ${agencyData?.theme_colors[0].g}, ${agencyData?.theme_colors[0].b})`,
        }}
      >
        <Link to={clientRoutes.agencyProfileView}>
          <button className="header-menu-profile-btn" onClick={handleClose}>
            Agency Profile
          </button>
        </Link>

        <div className="header-agency-image">
          <img
            src={getImageUrl(
              agencyData?.profile_image_ref?.original_file_path || ""
            )}
            alt={agencyData?.profile_image_ref?.file_name}
          />
        </div>

        <p
          className="header-menu-agency-name"
          style={{ color: `${agencyData?.design_text_color?.hex}` }}
        >
          {agencyData?.agency_trading_name}
        </p>
        <p
          className="header-menu-agency-email"
          style={{ color: `${agencyData?.design_text_color?.hex}` }}
        >
          {agencyData?.email}
        </p>
      </div>
      {/* <div className="header-menu-profile-border"></div> */}
      <div className="header-menu-bottom-contain-container">
        <div className="header-menu-agent-details">
          <div className="header-profile-image">
            <img
              src={getImageUrl(
                agencyData?.principal_agent_id?.profile_image_ref
                  ?.compressed_file_path || ""
              )}
              alt={agencyData?.principal_agent_id?.profile_image_ref?.file_name}
            />
          </div>
          <div className="header-menu-profile-top-contain">
            <p className="header-menu-profile-name">{`${agencyData?.principal_agent_first_name} ${agencyData?.principal_agent_last_name}`}</p>
            <p className="header-menu-profile-name-email">
              {agencyData?.principal_agent_id?.email || ""}
            </p>
          </div>
        </div>

        <p className="header-menu-agency-link" onClick={onClickSwitch}>
          {state?.isLoadingSwitch ? (
            <Loading />
          ) : (
            "Switch to Principal Agent Profile"
          )}
        </p>

        <div className="header-menu-profile-border"></div>
      </div>
    </div>
  );
};

export default AgencyMenuDetails;
